module.exports = __webpack_public_path__ + "img/ripe.5a431155.png";